import { observable, toJS } from "mobx";
import { E_TIPO_TELA } from "./Enum";

export default class SimulacaoServicosViewStore {

    @observable tipoTela = E_TIPO_TELA.Filtro;
    @observable simulacaoAtiva = false;
    @observable servicosAtivo = false;    

    alteraTela(tela)  {
        this.tipoTela = tela;
    }

    resetarSimulacao = () => {
        this.simulacaoAtiva = false;
        this.servicosAtivo = false;
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosViewStore.js